module.exports = __webpack_public_path__ + "img/live-4.ce418c25.png";